import React from 'react';
import { Box, Typography, Chip, Stack } from '@mui/material';
import type { ApproverRef } from '@/types/run-stage.types';

interface ApprovalPanelProps {
  approvers: ApproverRef[];
  isReadOnly?: boolean;
}

export const ApprovalPanel: React.FC<ApprovalPanelProps> = ({ approvers, isReadOnly }) => {
  return (
    <Box sx={{ p: 1.5 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
        Approvals ({approvers.length})
      </Typography>
      {approvers.length > 0 ? (
        <Stack spacing={1}>
          {approvers.map((a, i) => (
            <Box
              key={i}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                p: 1,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {a.user?.name || a.user?.email || '—'}
                </Typography>
                {a.approvedAt && (
                  <Typography variant="caption" color="text.secondary">
                    {new Date(a.approvedAt).toLocaleString()}
                  </Typography>
                )}
              </Box>
              <Chip
                label={a.status || 'PENDING'}
                size="small"
                color={
                  a.status === 'APPROVED' ? 'success' :
                  a.status === 'REJECTED' ? 'error' : 'default'
                }
                variant="outlined"
              />
            </Box>
          ))}
        </Stack>
      ) : (
        <Typography variant="body2" color="text.secondary">No approvals required.</Typography>
      )}
    </Box>
  );
};
